import { toast } from 'react-toastify';
import { LanguageLoader } from '../../assets/languages';
import jwt_decode from "jwt-decode";

export const JWTDecode = (Token) =>
{
	let tokenData = jwt_decode(Token);
	// Get mili second time stamp
	let timestamp = Date.now();
	// Convert second to mili second
	tokenData.exp = tokenData.exp + "000";
	// Check token is not expire
	if( tokenData.exp < timestamp)
	{
		localStorage.removeItem("token");
		return false;
	}
	return tokenData;
}

export const Toastify = (message) =>
{
	return toast(message, {
		toastId: "notify_toast"
	});
}

export const LoadingToast = (status) =>
{
	const selectedLanguage = localStorage.getItem("language");
	const language = LanguageLoader(selectedLanguage);
	return toast.loading(language.PLEASE_WAIT, {
		toastId: "loading_toast"
	});
};

export const ReactSelectOptions = options =>
{
	let newOptions = [];
	options = RefactorDropdown(options);
	for(const key in options)
	{
		newOptions.push({'value': key, 'label': options[key]})
	}
	return newOptions;
}

export const GetOptionsArray = (ReactSelectOptions, withoutKey=false) =>
{
	let newOptions = [];
	if(typeof ReactSelectOptions['value'] !== 'undefined' && typeof ReactSelectOptions['label'] !== 'undefined')
	{
		newOptions[ReactSelectOptions['value']] = ReactSelectOptions['label'];
	}
	else
	{
		for(const obj of ReactSelectOptions)
		{
			newOptions[obj.value] = obj.label;
		}
	}
	if(withoutKey)
	{
		newOptions = Object.keys(newOptions);
	}
	return newOptions;
}


export const Validation = (data, type='') =>
{
	const returnArray = {result: false, message: ''};
	const selectedLanguage = localStorage.getItem("language");
	const language = LanguageLoader(selectedLanguage);
	if(type === 'phone_number')
	{
		if (data.length === 0 || !data || data.length < 11)
		{
			returnArray.result = false;
			returnArray.message = language.ERROR.WRONG_PHONE_NUMBER_ERROR;
		}
	}
	if(type === 'email')
	{
		const regex = /^[\w-]+@([\w-]+\.)+[\w-]{2,4}$/g;
		if (data.length === 0 || regex.test(data.trim()) === false)
		{
			returnArray.result = false;
			returnArray.message = language.ERROR.WRONG_EMAIL_ERROR;
		}
	}
	return returnArray;
};


export const AddCommas = value =>
{
	if(typeof value === 'string')
	{
		value = parseFloat(value.replaceAll(',', ''));
	}
	if(!value || isNaN(value) || value === '')
	{
		return '0';
	}
	var x = value.toString().replace(/,/g, '').split('.');
	var x1 = x[0];
	var x2 = x.length > 1 ? '.' + x[1] : '';
	var rgx = /(\d+)(\d{3})/;
	while (rgx.test(x1))
	{
		x1 = x1.replace(rgx, '$1,$2');
	}
	return x1 + x2;
}

export const TreeManagementValue = (obj, value) =>
{
	let returnValue = '';
	if(obj && obj.length)
	{
		for(const item of obj)
		{
			if(item.id === value)
			{
				returnValue = item.name;
				return returnValue;
			}
			else if(item.children && item.children.length)
			{
				returnValue = TreeManagementValue(item.children, value);
				if(returnValue)
				{
					return returnValue;
				}
			}
		}
	}
}

export const DateFormat = (string, format=false) =>
{
	if(!string)
	{
		return '';
	}
	string = string.toString();
	let Int = new Date(string);
	let separator = '-';
	let stringArray, timeArray = [];
	let date = '';
	let time = '';
	let tz = '';
	if(document.documentElement.attributes.lang.value === 'fa' || document.documentElement.attributes.lang.value === 'fa_IR')
	{
		separator = '/';
		if(Int.getFullYear() >= 1900)
		{
			let persianDate = Int.toLocaleDateString('fa-IR-u-nu-latn').split('/');
			/* FORMATING */
			date = persianDate[0]+separator+('0'+(persianDate[1])).slice(-2)+separator+('0'+persianDate[2]).slice(-2);
			if((string.indexOf(' ') > -1) || (string.indexOf('T') > -1))
			{
				time = ('0'+Int.getHours()).slice(-2)+':'+('0'+Int.getMinutes()).slice(-2);
			}
			/* GET FORMATTED DATE */
			string = date+' '+time;
		}
		else
		{
			date = string;
			if(string.indexOf('T') > -1)
			{
				stringArray = string.split('T');
				date = stringArray[0];
				time = stringArray[1];
				date = date.replaceAll('-', separator);
			}
			else if(string.indexOf(' ') > -1)
			{
				stringArray = string.split(' ');
				date = stringArray[0];
				time = stringArray[1];
				date = date.replaceAll('-', separator);
			}
			time = time.replace('Z', '').replace('z', ' ');
			if(time.indexOf('+') > -1)
			{
				timeArray = time.split('+');
				time = timeArray[0];
				tz = '+'+timeArray[1];
			}
			else if(time.indexOf('-') > -1)
			{
				timeArray = time.split('-');
				time = timeArray[0];
				tz = '-'+timeArray[1];
			}
		}
	}
	else
	{
		/* FORMATING */
		date = Int.getFullYear()+separator+('0'+(Int.getMonth()+1)).slice(-2)+separator+('0'+Int.getDate()).slice(-2);
		time = ('0'+Int.getHours()).slice(-2)+':'+('0'+Int.getMinutes()).slice(-2);
	}
	/* GET FORMATTED DATE */
	string = date+' '+time;
	if(format)
	{
		string = <span dir="ltr" data-tz={tz}>{string}</span>;
	}
	return string;
}

export const FixPersianString = (string) => {
	var letters = {
		'q': 'ض',
		'w': 'ص',
		'e': 'ث',
		'r': 'ق',
		't': 'ف',
		'y': 'غ',
		'u': 'ع',
		'i': 'ه',
		'o': 'خ',
		'p': 'ح',
		'[': 'ج',
		']': 'چ',
		'a': 'ش',
		's': 'س',
		'd': 'ی',
		'f': 'ب',
		'g': 'ل',
		'h': 'ا',
		'j': 'ت',
		'k': 'ن',
		'l': 'م',
		';': 'ک',
		'\'': 'گ',
		'z': 'ظ',
		'x': 'ط',
		'c': 'ز',
		'v': 'ر',
		'b': 'ذ',
		'n': 'د',
		'm': 'پ',
		',': 'و',
		'C': 'ژ',
		'H': 'آ',
		'A': 'ؤ',
		'S': 'ئ',
		'G': 'أ',
		'L': '«',
		'K': '»'
	};
	let output = '';
	for (let i=0, il=string.length; i<il; i++)
	{
	  output += letters[string.charAt(i)] || string.charAt(i);
	}
	return output;
}

export const DateDBFormat = date =>
{
	if(typeof date === 'string')
	{
		date = ConvertNumbers(date);

	}
	const Int = new Date(date);
	let separator = '-';
	let string = Int.getFullYear()+separator+('0'+(Int.getMonth()+1)).slice(-2)+separator+('0'+Int.getDate()).slice(-2);
	return string;
}

export const ConvertNumbers = string =>
{
	string = string.toString().replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d));
	return string;
}

export const DownloadByContent = (content, filename, extension) =>
{
	let mime = '';
	if(extension)
	{
		mime = mimeTypes[extension];
	}
	else if(filename && filename.indexOf('.'))
	{
		mime = mimeTypes[filename.split('.').slice(-1)[0]];
	}
	if(mime && mime.length)
	{
		const downloadLink = document.createElement("a");
		downloadLink.href = 'data:'+mime+';base64,'+content;
		downloadLink.download = filename;
		downloadLink.click();
	}
	else
	{
		console.error('Download Failed: Unknown extension');
	}
}

export const mimeTypes = {
	'bmp': 'image/bmp',
	'css': 'text/css',
	'doc': 'application/msword',
	'docx': 'application/msword',
	'gif': 'image/gif',
	'gz': 'application/x-gzip',
	'htm': 'text/html',
	'html': 'text/html',
	'jpeg': 'image/jpeg',
	'jpg': 'image/jpeg',
	'json': 'application/json',
	'mp4': 'video/mp4',
	'ods': 'application/vnd.oasis.opendocument.spreadsheet',
	'otf': 'application/x-font-opentype',
	'pdf': 'application/pdf',
	'png': 'image/png',
	'ppt': 'application/vnd.ms-powerpoint',
	'pptx': 'application/vnd.ms-powerpoint',
	'pps': 'application/vnd.ms-powerpoint',
	'rtf': 'application/rtf',
	'svg': 'image/svg+xml',
	'svgz': 'image/svg+xml',
	'tif': 'image/tiff',
	'ttf': 'application/x-font-ttf',
	'txt': 'text/plain',
	'xls': 'application/vnd.ms-excel',
	'xlsx': 'application/vnd.ms-excel',
	'xml': 'application/xml',
	'woff': 'application/font-woff',
	'woff2': 'application/font-woff2',
	'zip': 'application/zip',
	'rar': 'application/x-rar-compressed',
};

export const GetPastDate = days => 
{
	const currentDate = new Date();
	currentDate.setDate(currentDate.getDate() - days);
	return currentDate;
}

export const RefactorDropdown = (target) =>
{
	// Moves the empty string key to "0" while keeping its value and reorders the rest.
	if (target && "" in target)
	{
		const { "": emptyValue, ...restOptions } = target;
		target = { "0": emptyValue, ...restOptions };
	}
	return target;
};
